import React, { FunctionComponent } from "react"
import { Link } from "react-router-dom"
import { Tooltip } from "@material-ui/core"
import { TransactionModel } from "./TransactionsTable"
import styles from "./TransactionGroupLink.module.scss"

interface TransactionGroupLinkProps {
    transactions: TransactionModel[]
}
export const TransactionGroupLink: FunctionComponent<TransactionGroupLinkProps> = props => {
    const { transactions } = props
    const referenceId = transactions[0].referenceId

    function hasAssociatedPrompt() {
        return !!transactions.find(
            o => (o.action === "APPROVE_AUDIO" || o.action === "UPLOAD_AUDIO") && !!o.prompt
        )
    }

    if (hasAssociatedPrompt()) {
        return (
            <Link
                id={`transaction-link-${referenceId}`}
                className={styles.TransactionGroupLink}
                to={{ pathname: "/files", search: `?transaction=${referenceId}` }}
                data-testid="transaction-link-enabled"
            >
                {referenceId}
            </Link>
        )
    }

    return (
        <Tooltip arrow title="No audio files for this reference id">
            <div data-testid="transaction-link-disabled">{referenceId}</div>
        </Tooltip>
    )
}
